import Members from './routes/member/Members.vue';

import Event from './routes/event/Event.vue';
import createEvent from './routes/event/routes/createEvent.vue';
import editEvent from './routes/event/routes/editEvent.vue';

import ClaimedBenefit from './routes/claimed_benefit/ClaimedBenefit.vue';
import createClaimedBenefit from './routes/claimed_benefit/component/createClaimedBenefit.vue';
import editClaimedBenefit from './routes/claimed_benefit/component/editClaimedBenefit.vue';

import PointSales from './routes/point_sales/PointSales.vue';
import createPointSales from './routes/point_sales/routes/createPointSales.vue';
import editPointSales from './routes/point_sales/routes/editPointSales.vue';

import VoucerService from './routes/voucer_service/VoucerService.vue';
import createVoucerService from './routes/voucer_service/routes/createVoucerService.vue';
import editVoucerService from './routes/voucer_service/routes/editVoucerService.vue';

import BenefitCategory from './routes/benefit_category/BenefitCategory.vue';
import createBenefitCategory from './routes/benefit_category/routes/createBenefitCategory.vue';
import editBenefitCategory from './routes/benefit_category/routes/editBenefitCategory.vue';

import BenefitType from './routes/benefit_type/BenefitType.vue';
import createBenefitType from './routes/benefit_type/routes/createBenefitType.vue';
import editBenefitType from './routes/benefit_type/routes/editBenefitType.vue';

import Benefit from './routes/benefit/Benefit.vue';
import createBenefit from './routes/benefit/routes/createBenefit.vue';
import editBenefit from './routes/benefit/routes/editBenefit.vue';

const PaxelinClubRoutes = [
    {
        path: 'members',
        name: 'Members',
        component: Members,
      },
    {
        path: 'event',
        name: 'Event',
        component: Event,
      },
    {
        path: 'create-event',
        name: 'createEvent',
        component: createEvent,
      },
    {
        path: 'edit-event/:id',
        name: 'editEvent',
        component: editEvent,
      },
    {
        path: 'point-sales',
        name: 'PointSales',
        component: PointSales,
      },
    {
        path: 'create-point-sales',
        name: 'createPointSales',
        component: createPointSales,
      },
    {
        path: 'edit-point-sales/:id',
        name: 'editPointSales',
        component: editPointSales,
      },
    {
        path: 'voucer-service',
        name: 'VoucerService',
        component: VoucerService,
      },
    {
        path: 'create-voucer-service',
        name: 'createVoucerService',
        component: createVoucerService,
      },
    {
        path: 'edit-voucer-service/:id',
        name: 'editVoucerService',
        component: editVoucerService,
      },
    {
        path: 'claimed-benefit',
        name: 'ClaimedBenefit',
        component: ClaimedBenefit,
      },
    {
        path: 'create-claimed-benefit',
        name: 'createClaimedBenefit',
        component: createClaimedBenefit,
      },
    {
        path: 'edit-claimed-benefit/:id',
        name: 'editClaimedBenefit',
        component: editClaimedBenefit,
      },
    {
        path: 'benefit-category',
        name: 'BenefitCategory',
        component: BenefitCategory,
    },
    {
        path: 'create-benefit-category',
        name: 'createBenefitCategory',
        component: createBenefitCategory,
    },
    {
        path: 'edit-benefit-category/:id',
        name: 'editBenefitCategory',
        component: editBenefitCategory,
    },
    {
        path: 'benefit-type',
        name: 'BenefitType',
        component: BenefitType,
    },
    {
        path: 'create-benefit-type',
        name: 'createBenefitType',
        component: createBenefitType,
    },
    {
        path: 'edit-benefit-type/:id',
        name: 'editBenefitType',
        component: editBenefitType,
    },
    {
        path: 'benefit',
        name: 'Benefit',
        component: Benefit,
    },
    {
        path: 'create-benefit',
        name: 'createBenefit',
        component: createBenefit,
    },
    {
        path: 'edit-benefit/:benefit_code',
        name: 'editBenefit',
        component: editBenefit,
    },
     
];

export default PaxelinClubRoutes;
